import { useCallback } from 'react'
import { batch, useSignal } from '@preact/signals-react'
import { acrissTable, categoriesTable, mappingType, selectedMappingId } from 'Pages/Admin/AdminMapping/@signals'
import { getSubmit, postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { useToast } from '@hooks'
import { formData, userData } from '@signals'
import { slaveId } from '@signals/user'

export default function useAdminMappingForm(method) {
	const isAcrissForm = mappingType.value === MAPPING_TYPE.ACRISS
	const backendUrl = isAcrissForm ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY

	const isFormSubmitting = useSignal(false)
	const isLoadingForm = useSignal(false)
	const { showToast } = useToast()
	const getMapping = useCallback(() => {
		if (selectedMappingId.value) {
			isLoadingForm.value = true
			getSubmit(`${backendUrl}/list`, { id: selectedMappingId.value }).then(res => batch(() => {
				formData.value = res
				isLoadingForm.value = false
			}))
		}
	}, [selectedMappingId.value])

	const submitPayload = useCallback(() => {
		isFormSubmitting.value = true
		postSubmit(`${backendUrl}/${method}`, formData.value = Object.fromEntries(Object.entries(formData.value).filter(([key]) => key !== "acrissOptions")))
			.then(res => {
				if(formData.value.uids.includes(slaveId.value || userData.value.uid)) {
					isAcrissForm
						? acrissTable.value = acrissTable.value.filter(({ idCustom }) => idCustom !== selectedMappingId.value)
						: categoriesTable.value = categoriesTable.value.filter(({ idCustom }) => idCustom !== selectedMappingId.value)
					isAcrissForm ? acrissTable.value = [...res?.length ? res[0] : [res], ...acrissTable.value] : categoriesTable.value = [...res?.length ? res[0] : [res], ...categoriesTable.value]
				}
			isFormSubmitting.value = false
			selectedMappingId.value = null
			formData.value = {}
		}).catch(() => {
			isFormSubmitting.value = false
			selectedMappingId.value = null
			showToast.error()
			formData.value = {}
		})
	}, [])

	return {
		submitPayload,
		getMapping,
		isFormSubmitting: isFormSubmitting.value,
		isLoadingForm: isLoadingForm.value,
	}
}